import React, { useRef } from 'react';
import { SidePanel } from '@saviynt/design-system';

// import { VIOLATIONS_TAB_LIST_FOOTER_KIND } from '../../../../shared/constants';
// import { useTypedSelector } from '../../../../shared/hooks';
import { testIds } from '../../../../shared/constants';
import { type ViolationsTabSidePanelRowContextState } from '../../data-layer/violationsTabTypes';

// import { ViolationsListActions } from '../ViolationsListActions';
import ViolationsGraphSidePanelBody from './ViolationsGraphSidePanelBody';

import './ViolationsGraphSidePanel.css';

interface ViolationsGraphSidePanelProps {
  rowContext: ViolationsTabSidePanelRowContextState;
  isSidePanelVisible: boolean;
  handleSidePanelBack: () => void;
  handleSidePanelClose: () => void;
}

/**
 * ViolationsGraphSidePanel
 */
function ViolationsGraphSidePanel({
  rowContext,
  isSidePanelVisible,
  handleSidePanelBack,
  handleSidePanelClose,
}: ViolationsGraphSidePanelProps) {
  // const {
  //   controls: { tabInAction },
  // } = useTypedSelector((state) => state.aag.violationsTab);

  const sidepanelRef = useRef(null);

  return (
    <SidePanel
      ref={sidepanelRef}
      layout={
        <ViolationsGraphSidePanelBody
          currentRowContext={rowContext}
          sidepanelRef={sidepanelRef}
          handleSidePanelBack={handleSidePanelBack}
          handleSidePanelClose={handleSidePanelClose}
        />
      }
      isOpen={isSidePanelVisible}
      onClose={() => handleSidePanelClose()}
      // footer={
      //   <ViolationsListActions
      //     kind={VIOLATIONS_TAB_LIST_FOOTER_KIND.FOOTER}
      //     tabInAction={tabInAction}
      //     rowContext={rowContext}
      //     isDisabled
      //   />
      // }
      isSidePanelNavigatingList
      isPreviousDisabled
      isNextDisabled
      isMobileWidth={false}
      isTabletWidth={false}
      className='Sod-ViolationsGraphSidePanel'
      classNames={{
        headerClassName: 'Sod-ViolationsGraphSidePanel-header',
        layoutClassName: 'Sod-ViolationsGraphSidePanel-layout',
        innerContentClassName: 'Sod-ViolationsGraphSidePanel-innerContent',
        footerClassName: 'Sod-ViolationsGraphSidePanel-footer',
      }}
      dataTestId={testIds.SOD_VIOLATIONS_TAB_SIDE_PANEL}
    />
  );
}

export default ViolationsGraphSidePanel;
